module.exports = __webpack_public_path__ + "dingbeauty-landing/img/instgram.ba9d874a.svg";